export const ADD_SNIPPET = 'ADD_SNIPPET'
export const DELETE_SNIPPET = 'DELETE_SNIPPET'
export const SET_SNIPPETS = 'SET_SNIPPETS'
export const SHOW_SNIPPETS_RAIL = 'SHOW_SNIPPETS_RAIL'
export const NAVIGATION_STORAGE_KEY = 'almanac-navigation'
export const OPEN_FOLDERS_STORAGE_KEY = 'almanac-open-folders'
export const SIDEBAR_WIDTH_KEY = 'almanac-sidebar-width'
